import { useOrganization } from '../../../../../hooks/use-organization';
import {
  isTeacherCreatedManually,
  type OrganizationTeacher,
} from '../../../../../modules/teacher/teacher';

type UseSchoolTeachersColumnsVisibilityReturn = {
  showEnrollmentStatusColumn: boolean;
  showIcon: (teacher: OrganizationTeacher) => boolean;
};

type UseSchoolTeachersColumnsVisibilityVariables = {
  teachers: OrganizationTeacher[];
};

function useSchoolTeachersColumnsVisibility({
  teachers,
}: UseSchoolTeachersColumnsVisibilityVariables): UseSchoolTeachersColumnsVisibilityReturn {
  const { isRosteringEnabled } = useOrganization();

  const hasManuallyEnrolledTeachers = teachers.some((teacher) =>
    isTeacherCreatedManually(teacher)
  );

  return {
    showEnrollmentStatusColumn:
      isRosteringEnabled && hasManuallyEnrolledTeachers,
    showIcon: (teacher: OrganizationTeacher) =>
      !teacher.isInvitation &&
      !teacher.isSchoolInvitation &&
      isTeacherCreatedManually(teacher),
  };
}

export { useSchoolTeachersColumnsVisibility };
